/** @jsxImportSource @emotion/react */
import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography } from '@mui/material';
import { Il8nContext } from '../../Helper/i18n';
import { useContext } from 'react';


function ExpansionGrid(props) {
    const { title, accordianData } = props
    const localeText = useContext(Il8nContext)


    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon css={{ color: "#24B7CC" }} />}>
                <Typography variant="body1" css={{ fontWeight: "bold" }}>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {accordianData || <Typography variant="body1" css={{ fontWeight: "bold" }}>{localeText?.ExpansionDetails}</Typography>}
            </AccordionDetails>
        </Accordion>
    );
}

export default ExpansionGrid;